import PropTypes from 'prop-types';
import { useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

// ===========================|| FIREBASE - SnackAlert ||=========================== //

const SnackAlert = ({ message, fieldName, fieldEdited, type, position = 'top-center', hideDuration = 4000 }) => {
    const [state, setState] = useState({
        open: true
    });
    const { open } = state;

    const msg = fieldName ? fieldMessage(fieldName, fieldEdited ? true : false) : message;

    const objPos = {
        vertical: 'top',
        horizontal: 'center'
    };
    const arrPos = position.split('-');
    if (arrPos.length >= 2) {
        objPos.vertical = arrPos[0];
        objPos.horizontal = arrPos[1];
    }

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    return (
        <>
            <Snackbar open={open} anchorOrigin={objPos} autoHideDuration={hideDuration} onClose={handleClose}>
                <Alert severity={type} variant="filled" onClose={handleClose} style={{ minWidth: '380px' }}>
                    {msg}
                </Alert>
            </Snackbar>
        </>
    );
};

SnackAlert.propTypes = {
    message: PropTypes.string,
    fieldName: PropTypes.string,
    fieldEdited: PropTypes.bool,
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    position: PropTypes.oneOf(['top-center', 'bottom-center', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
    hideDuration: PropTypes.number
};

export const fieldMessage = (field, edited = false) => {
    if (edited == false) {
        return `${field} جدید با موفقیت ثبت شد!`;
    } else {
        return `${field} با موفقیت ویرایش شد!`;
    }
};

export default SnackAlert;
